export const setCurrentUser = (data) => {
    return{
        type: 'FTECH_CURRENT_USER',
        payload: data
    }
}